import {ContentMetaResponseData} from '../type/ContentMetaResponseData.interface';
import {LoadAsset} from './LoadAsset.class';

export class MetaLoadAsset extends LoadAsset {
  public seriesId;
  public productId;

  public result?: ContentMetaResponseData;

  constructor({
    url,
    seriesId,
    productId,
  }: {
    url: string;
    seriesId: string;
    productId: string;
  }) {
    super({type: 'Meta', url});

    this.seriesId = seriesId;
    this.productId = productId;
  }
}
